import gql from 'graphql-tag';

const GraphQL = {
  Query: {
    ASSETS: gql`
      query Assets($types: [AssetType], $category: AssetOwnerCategory!) {
        assets(types: $types, category: $category) {
          assetkey
          owner
          contentType
          filename
          size
          hidden
          dateCreated
        }
      }
    `,
    ASSET_METADATA: gql`
      query AssetMetadata(
        $assetFolder: AssetFolder
        $assetkey: String
        $assetPath: String
      ) {
        assetMetadata(
          assetFolder: $assetFolder
          assetkey: $assetkey
          assetPath: $assetPath
        ) {
          assetkey
          owner
          contentType
          filename
          size
          hidden
          dateCreated
        }
      }
    `,
    PAYMENT_SETTINGS: gql`
      query PaymentSettings {
        paymentSettings {
          clientId
          currency
        }
      }
    `
  },
  Mutation: {
    DELETE_ASSETS: gql`
      mutation DeleteAssets($slugs: [String]!, $category: AssetOwnerCategory!) {
        deleteAssets(slugs: $slugs, category: $category)
      }
    `,
    DELETE_LEARNER_ASSETS: gql`
      mutation DeleteLearnerAssets(
        $slugs: [String]!
        $category: AssetOwnerCategory
      ) {
        deleteLearnerAssets(slugs: $slugs, category: $category)
      }
    `,
    UPSERT_PAYMENT_SETTINGS: gql`
      mutation UpsertPaymentSettings($input: PaymentSettingsInput!) {
        upsertPaymentSettings(input: $input) {
          clientId
          currency
        }
      }
    `,
    LINK_FILECONTENT: gql`
      mutation LinkFileContent($input: FileContentAttributes) {
        linkFileContent(input: $input) {
          contentkey
        }
      }
    `
  }
};

export default GraphQL;
